import Label from "lib/Label";
import "./index.scss";
import ErrorMessage from "lib/ErrorMessage";
import { useSelector,useDispatch } from "react-redux";
import Number from "lib/Number";
import { useState } from "react";
import { useEffect } from "react";

const Telephone = (props) => {
    const {
        placeholder,
        label,
        value,
        onChange,
        type,
        name,
        error,
        size,
        validators,
        is_disabled,selectedData,isEditable,
        formErr,
        setFormErr,
        clearFieldError
    } = props;

    let fieldErr = formErr[name]
    let callingCode = `${name}_code`
    let callingCodeErr = formErr[callingCode]

  const [selectCode, setSelectCode] = useState("");
  const [mobile, setMobile] = useState("");
  let completeNum;

  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const handleCountryCode = (e) => {
    const re = /^[\+\d]?(?:[\d\s()]*)?$/;
    const { name, value } = e.target;
    if (value == "" || re.test(value)) {
      setSelectCode(value);
      completeNum = value + "-" + mobile;
      onChange(name, completeNum);
    }
    if (formErr[callingCodeErr]) {
      clearFieldError && clearFieldError(callingCodeErr)
      delete(formErr[callingCodeErr])
      setFormErr && setFormErr(formErr)
    }
  };

    const handleChange = (e) => {
        const { name, value } = e.target
        const re = /^[0-9\b]+$/;
        if (value === '' || re.test(value)) {
            setMobile(value)
             clearFieldError && clearFieldError(callingCodeErr)
             completeNum =  selectCode +"-"+ value 
             onChange(name, completeNum)
        }
    }
    useEffect(() => {
        if(value){
            let data = value.split("-")
            setSelectCode(data[0])
            setMobile(data[1])
        }
    },[value])
    return (
      <>
        {label ? <Label label={label} validators={validators} /> : null}
        <div className="col-lg-3 col-md-12 col-sm-12 mb-2">
          <input
            name={name}
            className={`form-input ${
              errorClass && !selectCode
                ? errorClass
                : callingCodeErr && mobile && !selectCode
                ? "error_outline"
                : ""
            } ${!isEditable && "radioDisabled"}`}
            placeholder={"+221"}
            value={selectCode}
            disabled={isEditable ? false:true}
            maxLength={6}
            onChange={handleCountryCode}
          />
          {error?.length !== 0 && !selectCode  ? (
            <ErrorMessage error={"This field is mandatory"} />
          ) : callingCodeErr && mobile && !selectCode  ? (
            <ErrorMessage error={"This field is required"} />
          ) : null}
        </div>
        <div className="col-lg-9 col-md-12 col-sm-12 mobile_number_container">
          <Number
            name={name}
            is_disabled={is_disabled}
            className={`${errorClass}`}
            placeholder={placeholder}
            value={mobile}
            onChange={handleChange}
            isEditable={isEditable}
            error={
              error && !mobile
                ? error
                :  fieldErr 
                ? [fieldErr? fieldErr?.err:"This field mandatory"]
                : null
            }
          />
        </div>

    </>
  );
};

export default Telephone;
